package pwgs.ui.scenes.logoutscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene

class MLogoutScene(props: LogoutSceneProps) : AScene<LogoutSceneProps, LogoutSceneModel, LogoutSceneState, LogoutControllerFe>(props) {

    override fun createController() : LogoutControllerFe {
        return LogoutControllerFe(props, this)
    }

    override fun initState() : LogoutSceneState {
        return LogoutSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MLogoutScene.model
        +"Logging out..."
    }
}

class LogoutSceneState {

}

fun Components.LogoutScene(props: LogoutSceneProps) = this.registerComponent(MLogoutScene(props), {})
